function findLowValue(array, parameter) {
  // Filter out null and undefined values only
  const validValues = array
    .map((item) => item[parameter])
    .filter((value) => value !== null && value !== undefined);

  // If no valid values, return null
  if (validValues.length === 0) {
    return null;
  }

  return validValues.reduce(
    (min, value) => (value < min ? value : min),
    validValues[0]
  );
}

function findHighValue(array, parameter) {
  // Filter out null and undefined values only
  const validValues = array
    .map((item) => item[parameter])
    .filter((value) => value !== null && value !== undefined);

  // If no valid values, return null
  if (validValues.length === 0) {
    return null;
  }

  return validValues.reduce(
    (max, value) => (value > max ? value : max),
    validValues[0]
  );
}

export function calculateChange(bars) {
  return bars.map((bar, i, arr) => {
    let previousBar = arr[i + 1];
    bar.changeAmount = previousBar
      ? bar.ClosePrice - previousBar.ClosePrice
      : 0;
    return bar;
  });
}

export function calculateLows(bars) {
  return {
    OpenPrice: findLowValue(bars, 'OpenPrice'),
    LowPrice: findLowValue(bars, 'LowPrice'),
    HighPrice: findLowValue(bars, 'HighPrice'),
    ClosePrice: findLowValue(bars, 'ClosePrice'),
    changeAmount: findLowValue(bars, 'changeAmount'),
    Volume: findLowValue(bars, 'Volume'),
    AverageDailyVolume: findLowValue(bars, 'AverageDailyVolume')
  };
}

export function calculateHighs(bars) {
  return {
    OpenPrice: findHighValue(bars, 'OpenPrice'),
    LowPrice: findHighValue(bars, 'LowPrice'),
    HighPrice: findHighValue(bars, 'HighPrice'),
    ClosePrice: findHighValue(bars, 'ClosePrice'),
    changeAmount: findHighValue(bars, 'changeAmount'),
    Volume: findHighValue(bars, 'Volume'),
    AverageDailyVolume: findHighValue(bars, 'AverageDailyVolume')
  };
}
